export default function DisposerProfile() {
  return (
    <main id="disposer-home">Please Sign Up or Login to place an order</main>
  );
}
